// extracted by mini-css-extract-plugin
export default {"menssage":"Menssage_menssage__NUtbp","success":"Menssage_success__39rR3","error":"Menssage_error__jzsrP"};